import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { UiRmsModule } from '../../../../projects/rms/app/shared/ui-rms/ui-rms.module';
import { UsersListComponent } from './users-home/users-list/users-list.component';
import { UsersHomeComponent } from "./users-home/users-home.component";
import { CoreUiModule } from "../../shared/core-ui/core-ui.module";
import { IdentityAccountsService } from '../../shared/core-ndms/services/identity-accounts.service';
import { UserEditComponent } from './users-home/user-edit/user-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UsersImportComponent } from "./users-home/users-import/users-import.component";
import { NdmsUsersService } from '../../shared/core-ndms/services/ndms-users.service';
import { UserSearchComponent } from './users-home/user-search/user-search.component';
import { UserAppsListComponent } from './users-home/user-apps-list/user-apps-list.component';
import { SearchRespondersModalComponent } from './users-home/search/search-responders-modal.component';
import { ResponderSearchComponent } from './users-home/search/responder-search/responder-search.component';

@NgModule({
  declarations: [
    UsersListComponent, 
    UsersHomeComponent, 
    UserEditComponent,
    UsersImportComponent,
    UserSearchComponent,
    UserAppsListComponent,
    SearchRespondersModalComponent,
    ResponderSearchComponent
  ],
  imports: [
    CommonModule,
    CoreUiModule,
    FormsModule,
    CheckboxModule,
    ReactiveFormsModule,
    UiRmsModule
  ],
  entryComponents: [
    UserEditComponent,
    UsersImportComponent,
    UserSearchComponent,
    SearchRespondersModalComponent
  ],
  exports: [
    SearchRespondersModalComponent
  ],
  providers: [
    IdentityAccountsService,
    NdmsUsersService
  ]
})
export class UsersModule { }
